import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { useEffect, useState } from 'react';
import { generateDemoCompanyWithAssessments } from '@/lib/seedNom35Demo';

export function OwnerDashboardPage() {
  const [seeding, setSeeding] = useState(false);
  const [toastMsg, setToastMsg] = useState<string | null>(null);
  const [toastKind, setToastKind] = useState<'success' | 'error' | 'info'>('info');

  useEffect(() => {
    if (!toastMsg) return;
    const t = window.setTimeout(() => setToastMsg(null), 4000);
    return () => window.clearTimeout(t);
  }, [toastMsg]);

  const showToast = (kind: 'success' | 'error' | 'info', msg: string) => {
    setToastKind(kind);
    setToastMsg(msg);
  };

  const handleGenerateDemo = async () => {
    if (seeding) return;
    if (!window.confirm('Esto creará una Empresa Demo con 100 empleados y evaluaciones cerradas. ¿Continuar?')) return;
    setSeeding(true);
    showToast('info', 'Generando demo... Esto puede tardar unos segundos.');
    try {
      const r = await generateDemoCompanyWithAssessments();
      showToast('success', `Demo creada: empresa ${r.companyId} (${r.employeesCreated} empleados).`);
    } catch (err) {
      console.error('Error generando demo:', err);
      showToast('error', err instanceof Error ? err.message : 'Error al generar demo');
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Panel Owner</h1>
      <p className="text-muted-foreground">
        Acceso a todas las empresas, usuarios y métricas globales.
      </p>
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Empresas</CardTitle>
          </CardHeader>
          <CardContent>
            <a href="/owner/companies" className="text-sm text-primary hover:underline">
              Gestionar empresas →
            </a>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Usuarios</CardTitle>
          </CardHeader>
          <CardContent>
            <a href="/owner/users" className="text-sm text-primary hover:underline">
              Ver usuarios →
            </a>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Demo NOM-035 + Clima</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button onClick={handleGenerateDemo} disabled={seeding}>
            {seeding ? 'Generando...' : 'Generar Demo Completo (100 Emp)'}
          </Button>
          <p className="text-sm text-muted-foreground">
            Login demo: <span className="font-medium">demo@psytalent.com</span> / <span className="font-medium">demo1234</span>
          </p>
        </CardContent>
      </Card>

      {toastMsg && (
        <div
          className={[
            'fixed right-4 top-4 z-50 max-w-sm rounded-md border px-4 py-3 text-sm shadow-lg',
            toastKind === 'success'
              ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
              : toastKind === 'error'
                ? 'border-red-200 bg-red-50 text-red-900'
                : 'border-border bg-background text-foreground',
          ].join(' ')}
          role="status"
        >
          {toastMsg}
        </div>
      )}
    </div>
  );
}
